<template>
  <div class="topic">
    <div class="topic-banner">
      <img :src="topic" alt="专题banner"/>
      <div class="topic-banner-text">
        <span>—</span>
        <span>专</span>
        <span>题</span>
        <span>文</span>
        <span>章</span>
        <span>—</span>
      </div>
    </div>
    <div class="line"><span>全部专题</span><span></span></div>
    <div class="topic-content">
      <topic-card v-for="(item, index) in topics" :style="{marginLeft: index % 4 === 0 ? '' : '44px'}"  :hotTopic="item"  :key="index"></topic-card>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import TopicCard from '../components/common/TopicCard'
import topic from '../assets/img/topic.png'
export default {
  name: 'topic',
  components: { TopicCard },
  computed: {
    ...mapGetters('topic', ['topics'])
  },
  data () {
    return {
      topic,
      hotTopics: []
    }
  },
  methods: {
    ...mapActions('topic', ['getTopics'])
  },
  created () {
    this.getTopics()
  }
}
</script>

<style lang="scss">
.topic {
  >.topic-banner {
    position: relative;
    height: 132px;
    >img {
      width: 100%;
    }
    >.topic-banner-text {
      height: 48px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate3d(-50%, -50%, 0);
      line-height: 48px;
      font-size: 40px;
      color: #ffffff;
      >:not(:first-child) {
        margin-left: 50px;
      }
    }
  }
   >.line {
    margin: 40px 0 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 16px;
    color: #333333;
    >:nth-child(2) {
      display: inline-block;
      width: calc(100% - 80px);
      border-top: 1px solid #EAEAEA;
    }
  }
  >.topic-content {
    padding-top: 40px;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
  }
}
</style>